<div class="knowledge-base">
  <!-- ── Header ─────────────────────────────────────────────────────────── -->
  <ui-page-header [title]="'knowledge_base.title' | translate" lucideIcon="Book"> </ui-page-header>

  <!-- ── Level 1 tabs. Products leads and is the landing tab. ───────────── -->
  <div class="knowledge-base__tabs">
    <div
      class="knowledge-base__tab"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'products'"
      [class.active]="activeL1Tab === 'products'"
      (click)="onL1TabChange('products')"
    >
      {{ "knowledge_base.tab.products" | translate }}
    </div>
    <div
      class="knowledge-base__tab"
      role="tab"
      [attr.aria-selected]="activeL1Tab === 'documents'"
      [class.active]="activeL1Tab === 'documents'"
      (click)="onL1TabChange('documents')"
    >
      {{ "knowledge_base.tab.documents" | translate }}
    </div>
  </div>

  <!-- ── Products tab content ─────────────────────────────────────────── -->
  <app-products-tab *ngIf="activeL1Tab === 'products'"></app-products-tab>

  <!-- ── Documents tab content ──────────────────────────────────────────
       *ngIf, not [hidden]: the tab dispatches LoadDocuments() on init, and
       since Products became the landing tab that request would fire on every
       visit to Knowledge for a tab most users never open. Filters, sort and
       the document list live in the store, so they survive the unmount. -->
  <app-documents-tab *ngIf="activeL1Tab === 'documents'"></app-documents-tab>
</div>
